import './bootstrap';
// import '../css/app.css';  // Remove this line - CSS is handled as separate entry point
console.log('app.js loaded');